import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Eicherbusonrentinpune() {



  const cardData =
  {
    keyword: 'Eicher Bus on Rent in Pune',
    heading: 'Sanavi Travels: Eicher Bus on Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable Eicher Bus on Rent in Pune, providing safe, comfortable, and well-maintained transportation solutions for corporate groups, schools, colleges, families, tourists, weddings, and events. Our fleet of Eicher buses ranging from 32 to 50 seaters is equipped with modern amenities such as air-conditioning, spacious seating, ample legroom, and generous luggage space, ensuring a smooth and hassle-free journey for both local and outstation trips. With experienced and licensed chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and safe travel. We offer convenient doorstep pickup across Pune including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering popular destinations such as Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, Goa, Aurangabad, Kolhapur, Konkan, and more. Choose Sanavi Travels to rent an Eicher bus in Pune, delivering comfort, safety, and a seamless group travel experience.',

    top: 'Top Places to Visit in Pune  with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical monument and a symbol of Maratha pride. Once the seat of Peshwa Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and well-laid gardens. Despite being partially destroyed by fire, the ruins still echo royal grandeur. The evening light-and-sound show brings Maratha history to life, making Shaniwar Wada the cultural and historical heart of Pune."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a landmark deeply connected to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying photographs, personal belongings, and historical documents. The palace’s sprawling gardens and Italian-style architecture create a serene ambiance. Aga Khan Palace is a symbol of sacrifice, peace, and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered spiritual site, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, draws thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations, music, and cultural events. The temple trust is also known for extensive charitable work. Dagdusheth Ganpati represents the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fort famous for the heroic sacrifice of Tanaji Malusare in 1670 for Chhatrapati Shivaji Maharaj. Situated atop a rugged hill, the fort offers panoramic views of the Sahyadri ranges. Visitors can trek or drive up to explore ancient gates, memorials, and viewpoints. Sinhagad combines history, adventure, and natural beauty, making it a favorite among tourists and trekkers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Located in the busy city center, it offers a calm and meditative atmosphere. Monolithic pillars and ancient carvings showcase early Indian architectural excellence. Pataleshwar is a hidden heritage retreat offering spiritual solace in Pune."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, representing India’s cultural and artistic heritage. The collection includes musical instruments, traditional household items, sculptures, and ornaments. The recreated Mastani Mahal is a highlight. The museum is a must-visit for art, history, and culture enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering stunning panoramic views of the city. After climbing 103 stone steps, visitors reach the Parvati Temple complex, built during the Peshwa era. Smaller shrines and a museum enhance its cultural appeal. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort attracts visitors from around the world. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. The serene environment promotes relaxation and personal growth. Osho Ashram is Pune’s international center for spiritual and holistic wellness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, arched bridges, and manicured lawns create a tranquil environment. Families, joggers, and photography enthusiasts enjoy leisurely walks. The garden blends Japanese aesthetics with Indian nature, offering a peaceful sanctuary in the urban landscape."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune, especially during monsoon. The reservoir and surrounding hills offer scenic views, while street vendors provide local snacks and refreshments. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla Dam is ideal for weekend getaways, sunset views, and family outings."
  }
]
,




"services": [
  {
    "name": "Eicher Bus on Rent in Pune",
    "description": "Eicher Bus on Rent in Pune offers well-maintained buses for local travel, outstation trips, and special events. Spacious seating and professional drivers ensure a safe, comfortable, and enjoyable journey for families, corporate groups, and tourists."
  },
  {
    "name": "Eicher Bus Hire Pune",
    "description": "Eicher Bus Hire Pune provides flexible rental services for short and long-distance travel. Equipped with comfortable seating and experienced chauffeurs, these buses make group travel convenient, reliable, and hassle-free."
  },
  {
    "name": "AC Eicher Bus Pune",
    "description": "AC Eicher Bus Pune offers air-conditioned buses for a cool and comfortable travel experience. Ideal for corporate trips, family outings, or tourist tours, ensuring a relaxing journey with professional drivers."
  },
  {
    "name": "Luxury Eicher Bus Rental Pune",
    "description": "Luxury Eicher Bus Rental Pune provides premium buses with plush interiors, modern amenities, and ample luggage space. Perfect for VIP travel, weddings, corporate events, or long-distance trips, offering a stylish and comfortable journey."
  },
  {
    "name": "Corporate Eicher Bus Pune",
    "description": "Corporate Eicher Bus Pune caters to business groups and office staff, providing well-equipped buses for corporate outings, meetings, or conferences. Chauffeurs ensure punctuality, safety, and smooth travel."
  },
  {
    "name": "Wedding Eicher Bus Pune",
    "description": "Wedding Eicher Bus Pune provides spacious and comfortable buses for transporting guests during weddings. Professional drivers ensure reliable and hassle-free travel for all attendees."
  },
  {
    "name": "Outstation Eicher Bus Pune",
    "description": "Outstation Eicher Bus Pune offers buses for long-distance travel outside Pune. Well-maintained vehicles, experienced chauffeurs, and comfortable seating ensure a safe and enjoyable journey for families, tourists, and corporate groups."
  },
  {
    "name": "Affordable Eicher Bus Pune",
    "description": "Affordable Eicher Bus Pune provides budget-friendly rental options without compromising on comfort or safety. Ideal for families, friends, and corporate groups looking for economical travel solutions."
  },
  {
    "name": "Chauffeur Driven Eicher Bus",
    "description": "Chauffeur Driven Eicher Bus offers professional drivers to manage routes and traffic, allowing passengers to relax throughout the journey. Perfect for local travel, outstation trips, or event transportation."
  },
  {
    "name": "Group Travel Eicher Bus Pune",
    "description": "Group Travel Eicher Bus Pune caters to large groups requiring reliable and spacious buses. Ideal for corporate outings, school trips, family tours, or friends traveling together, ensuring a smooth and enjoyable journey."
  },
  {
    "name": "Best Eicher Bus Pune",
    "description": "Best Eicher Bus Pune offers top-quality buses and professional service for a superior travel experience. Comfortable seating, attentive drivers, and well-maintained vehicles ensure safe, punctual, and hassle-free journeys."
  },
  {
    "name": "Pune Eicher Bus Booking",
    "description": "Pune Eicher Bus Booking provides convenient online reservations for Eicher buses in Pune. Flexible booking options, reliable vehicles, and professional chauffeurs ensure seamless travel for local tours, outstation trips, and events."
  },
  {
    "name": "Tourist Eicher Bus Pune",
    "description": "Tourist Eicher Bus Pune offers buses for sightseeing and tourist travel around Pune. Spacious, comfortable, and equipped for long-distance travel, these buses are ideal for exploring the city and nearby attractions."
  },
  {
    "name": "Event Eicher Bus Pune",
    "description": "Event Eicher Bus Pune provides buses for weddings, corporate events, festivals, and other gatherings. Spacious interiors and professional drivers ensure safe and convenient transport for all attendees."
  },
  {
    "name": "Family Trip Eicher Bus Pune",
    "description": "Family Trip Eicher Bus Pune ensures comfortable and safe travel for families on day trips, weekend getaways, or long-distance tours. Well-maintained buses with professional drivers provide a stress-free travel experience for all family members."
  }
],
"tableData": [
  ["Eicher Bus on Rent in Pune", "Eicher Bus Hire Pune"],
  ["AC Eicher Bus Pune", "Luxury Eicher Bus Rental Pune"],
  ["Corporate Eicher Bus Pune", "Wedding Eicher Bus Pune"],
  ["Outstation Eicher Bus Pune", "Affordable Eicher Bus Pune"],
  ["Chauffeur Driven Eicher Bus", "Group Travel Eicher Bus Pune"],
  ["Best Eicher Bus Pune", "Pune Eicher Bus Booking"],
  ["Tourist Eicher Bus Pune", "Event Eicher Bus Pune"],
  ["Family Trip Eicher Bus Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Eicher Bus on Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable Eicher bus rental services in Pune, perfect for group tours, corporate travel, school outings, and long-distance journeys with comfort and safety."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Eicher Buses",
    "WhyChoosedescription": "Travel in air‑conditioned, clean, and well‑serviced Eicher buses designed to provide a smooth and relaxing journey for all passengers."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune Routes",
    "WhyChoosedescription": "Our professional and licensed drivers are familiar with Pune city, highways, and surrounding areas, ensuring safe, punctual, and stress‑free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront and clear pricing for Eicher bus rentals in Pune, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and travel‑related queries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from hourly, half‑day, full‑day, one‑way, round‑trip, or customized rental plans based on your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All Eicher buses are thoroughly cleaned and sanitized before every trip to ensure passenger safety and hygiene."
  },
  {
    "WhyChooseheading": "Reliable and On‑Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Eicher bus rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide Eicher buses on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers well‑maintained and comfortable Eicher buses for rental in Pune.'
  },
  {
    question: 'How can I book an Eicher bus in Pune with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What seating capacities are available for Eicher buses?',
    answer: 'We provide Eicher buses in various seating configurations suitable for groups of different sizes.'
  },
  {
    question: 'Are drivers included with the Eicher bus rental?',
    answer: 'Yes, all rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the Eicher bus rental service available 24x7?',
    answer: 'Yes, our Eicher bus rental service is available round the clock for bookings and travel assistance.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all Eicher buses are thoroughly cleaned and sanitized before each journey.'
  },
  {
    question: 'Can I customize the Eicher bus rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans according to your travel needs.'
  },
  {
    question: 'What payment options are available for Eicher bus bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Patil',
    feedback: 'Booked an Eicher bus from Sanavi Travels in Pune. Very comfortable and smooth journey with top‑notch service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Divya Kulkarni',
    feedback: 'Excellent experience! Spacious Eicher bus, professional driver, and on‑time service. Highly recommended!',
    rating: 5
  }
];












































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Eicher Bus on Rent in Pune - Sanavi Travels",
  "description": "Hire Eicher buses on rent in Pune with Sanavi Travels. AC and luxury Eicher buses for corporate travel, weddings, outstation trips, family outings, tourist travel, events, and comfortable chauffeur-driven group transportation.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};



  return (
    <div>
<Helmet>
  <title>
    Eicher Bus on Rent in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and luxury Eicher buses on rent in Pune with Sanavi Travels. Perfect for corporate travel, weddings, outstation trips, family outings, tourist travel, events, and group transportation."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Eicherbusonrentinpune;